import { HttpContextToken, HttpRequest } from '@angular/common/http';

export const SkipByLoadingInterceptorContext = new HttpContextToken(() => true);
export const isSkippedByLoadingInterceptorContext = <Body>(
  request: HttpRequest<Body>,
): boolean => {
  return request.context.has(SkipByLoadingInterceptorContext);
};
